import React, { useState } from 'react';
import InterestedGroupCard from '../components/InterestedGroupCard';
import { Container, Row, Col, Alert } from 'react-bootstrap';

const mockGroups = [
  {
    id: 'northside_001',
    name: 'Northside Hospital',
    location: 'Atlanta, GA',
    settings: ['OR', 'ASC'],
    rate: 180,
    schedule: 'Mon–Thu · Start: May'
  },
  {
    id: 'cedars_002',
    name: 'Cedars-Sinai Medical Center',
    location: 'Los Angeles, CA',
    settings: ['OR', 'ICU'],
    rate: 190,
    schedule: 'Mon–Fri · Start: June'
  }
];

const CRNAInterestDemoPage = () => {
  const [interestedGroups, setInterestedGroups] = useState(mockGroups);
  const [matched, setMatched] = useState([]);
  const [dismissed, setDismissed] = useState([]);

  const handleMatch = (groupId, message) => {
    const group = interestedGroups.find(g => g.id === groupId);
    setMatched(prev => [...prev, { ...group, message }]);
    setInterestedGroups(prev => prev.filter(g => g.id !== groupId));
  };

  const handleDismiss = (groupId) => {
    const group = interestedGroups.find(g => g.id === groupId);
    setDismissed(prev => [...prev, group]);
    setInterestedGroups(prev => prev.filter(g => g.id !== groupId));
  };

  return (
    <Container className="py-5">
      <h2 className="mb-4 text-center">👀 Groups Interested in You</h2>
      <Row className="justify-content-center">
        {interestedGroups.length === 0 && (
          <Alert variant="success" className="text-center">
            🎉 You’ve reviewed all interested groups!
          </Alert>
        )}

        {interestedGroups.map(group => (
          <Col key={group.id} md={6} lg={5} className="mb-4">
            <InterestedGroupCard
              group={group}
              onMatch={handleMatch}
              onDismiss={handleDismiss}
            />
          </Col>
        ))}

        {matched.length > 0 && (
          <div className="mt-5">
            <h5>✅ Matched Groups:</h5>
            <ul>
              {matched.map(match => (
                <li key={match.id}>
                  {match.name}
                  {match.message && <span className="text-muted"> — "{match.message}"</span>}
                </li>
              ))}
            </ul>
          </div>
        )}

        {dismissed.length > 0 && (
          <div className="mt-4">
            <h6 className="text-muted">Not Interested:</h6>
            <ul>
              {dismissed.map(d => (
                <li key={d.id}>{d.name}</li>
              ))}
            </ul>
          </div>
        )}
      </Row>
    </Container>
  );
};

export default CRNAInterestDemoPage;
